<template>
  <v-col cols="12" md="8">
    <v-card color="white">
      <v-container>
        <div class="d-flex justify-space-between">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn text icon v-on="on" @click="$router.go(-1)">
                <v-icon>fa-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Voltar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isAdmin">
            <template v-slot:activator="{ on }">
              <v-btn text icon v-on="on" @click="$router.push({ name: 'Edita Documento', params: { id: article._id } })">
                <v-icon>fa-edit</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </div>
        <v-card-title>{{ article.titulo }}</v-card-title>
        <v-card-text>
          <div
            v-if="article.tags && !!article.tags.length"
            class="mb-3"
          >
            <v-chip
              v-for="tag in article.tags"
              :key="tag._id"
              :color="tag.cor"
              small
              outlined
              class="ma-1"
            >{{ tag.descricao }}</v-chip>
          </div>
          <div class="markdown-container">
            <div v-if="article && article.conteudo" class="conteudo" v-html="compiledMarkdown"></div>
          </div>
          <div class="feedback">
            <div>
              <span>Esse documento foi útil?</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text icon small class="mx-3" v-on="on">
                    <v-icon>fa-thumbs-up</v-icon>
                  </v-btn>
                </template>
                <span>Gostei</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text icon small v-on="on">
                    <v-icon>fa-thumbs-down</v-icon>
                  </v-btn>
                </template>
                <span>Não Gostei</span>
              </v-tooltip>
            </div>
          </div>
          <div class="last-update text-right">
            Atualizado em: {{ article.updatedAt | dateMonthYear }}
          </div>
        </v-card-text>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import marked from 'marked';
import * as _ from 'lodash';
import Article from '../../domain/article/Article';

export default {
  name: 'ArticleView',
  props: ['id'],
  data: () => ({
    article: new Article(),
  }),
  computed: {
    ...mapGetters(['loading', 'isAdmin']),
    compiledMarkdown() {
      return marked(this.article.conteudo);
    }
  },
  methods: {
    ...mapActions(['fetchArticleById']),
    async getArticle() {
      const article = await this.fetchArticleById(this.id);
      this.article = { ...article };
    },
  },
  created() {
    this.getArticle();
  }
}
</script>

<style scoped>
.conteudo {
  white-space: pre-wrap;
}
.feedback {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin-top: 40px;
  box-shadow: var(--boxshadow);
}
.feedback > div {
  display: flex;
  align-items: center;
}
.feedback span {
  font-size: 1.125rem;
}
.feedback button:hover {
  color: #1976d2;
}
.last-update {
  margin-top: 40px;
  font-style: italic;
}
</style>